import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { proposalTemplateEndpoints } from '@/lib/api/endpoints';
import { proposalTemplateKeys } from '@/lib/queryKeys';
import type { ProposalTemplate } from '@/types/proposalTemplate';

/**
 * Fetches a single proposal template by ID from the operations microservice.
 */
export function useProposalTemplate(id: string) {
  return useApiQuery<ProposalTemplate>({
    queryKey: proposalTemplateKeys.detail(id),
    queryFn: () => apiGet<ProposalTemplate>(operationsClient, proposalTemplateEndpoints.detail(id)),
    enabled: Boolean(id),
  });
}
